var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMoreVertical = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M150 200c11.046 0 20 8.954 20 20v20c0 11.046-8.954 20-20 20h-20c-11.046 0-20-8.954-20-20v-20c0-11.046 8.954-20 20-20zm0-90c11.046 0 20 8.954 20 20v20c0 11.046-8.954 20-20 20h-20c-11.046 0-20-8.954-20-20v-20c0-11.046 8.954-20 20-20zm0-90c11.046 0 20 8.954 20 20v20c0 11.046-8.954 20-20 20h-20c-11.046 0-20-8.954-20-20V40c0-11.046 8.954-20 20-20z"
})));
export default SvgMoreVertical;